import React from 'react';

interface Props {
  title: string;
}

const Title: React.FC<Props> = ({ title }) => {
  return <h1 style={{ fontSize: 20, textAlign: 'center' }}>{title}</h1>;
};

export default Title;
